/**
 * Concatenates the provided short link with the base URL from the environment configuration.
 *
 * @param {string} short_link - The short link to be appended to the base URL.
 * @return {string} The complete URL constructed by combining the base URL and the short link.
 */
export function formatShortLink(short_link) {
    return process.env.VUE_APP_URL + short_link
}
